<div class="close-button">
  <button mat-icon-button (click)="download()">
    <mat-icon>cloud_download</mat-icon>
  </button>
  <button tabIndex="-1" mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

@if (data.isPdf) {
  <div class="h-full w-full pt-[40px]">
    <ng2-pdfjs-viewer
      #pdfViewer
      [pdfSrc]="data.url"
      [download]="false"
      [openFile]="false"
      [locale]="locale ?? ''"></ng2-pdfjs-viewer>
  </div>
} @else {
  <div
    class="align-center container-img mt-[40px] flex w-full justify-center"
    style="height: calc(100% - 40px)">
    <img
      [src]="data.url"
      class="m-[auto] max-h-full"
      alt="{{ 'unsupportedFormat' | translate }}" />
  </div>
}
